import { Button, Dialog, DialogActions, DialogContent, Grid, Stack, TextField, Typography } from '@mui/material';
import { useState } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router';
import { store } from 'store';
import { SET_DEFAULT_STEP_NAME, SET_DEFAULT_STEP_NAME_FRENCH, SET_STEPS } from 'store/actions';
import { DefaultRootStateProps } from 'types';
// import FormLocales from '../form-builder/FormLocales';
import FormContainer from '../inputs/FormContainer';

const FormTitle = ({
  onConfirm,
  onClose,
  open,
  isAStep,
  stepIndex,
  isFromTemplate,
  isEditing,
  isClinicDocuments,
  documentId,
  targetAudience
}: any) => {
  const intl = useIntl();
  const navigate = useNavigate();
  const formData = useSelector((state: DefaultRootStateProps) => state.formBuilder);
  console.log(formData, 'FDS');
  console.log(
    formData?.type === 'stepper'
      ? formData?.steps[0]?.title || ''
      : formData?.template
      ? formData?.steps?.length && formData?.steps[0]?.title
      : '',
    'title'
  );
  const [title, setTitle] = useState<string>(
    formData?.type === 'stepper'
      ? (formData?.steps?.length && formData?.steps[0]?.title) || ''
      : formData?.defaultStepName || (formData?.steps?.length && formData?.steps[0]?.title)
  );
  const [titleFrench, setTitleFrench] = useState<string>(
    formData?.type === 'stepper'
      ? formData?.steps[0]?.titleFrench || ''
      : formData?.defaultStepNameFrench || (formData?.steps?.length && formData?.steps[0]?.titleFrench)
  );

  return (
    // <FormLocales>
    <Dialog maxWidth="sm" fullWidth onClose={onClose} sx={{ '& .MuiDialog-paper': { p: 0 } }} open={open}>
      <FormContainer>
        <DialogContent>
          <Stack>
            <Typography sx={{ fontWeight: 'bold' }}>
              {isAStep ? (
                <FormattedMessage
                  defaultMessage="Step {stepIndex}"
                  values={{
                    stepIndex: stepIndex + 1
                  }}
                />
              ) : (
                <FormattedMessage defaultMessage="Form title" />
              )}
            </Typography>
            <Stack gap={1}>
              <TextField
                name="form-title"
                required
                placeholder={(isAStep ? `Enter step ${stepIndex + 1} title` : 'Please enter form title to proceed') as string}
                value={title}
                onChange={(e) => {
                  setTitle(e.target.value);
                }}
              />
              {formData?.lng?.includes('fr') ? (
                <TextField
                  name="form-title-french"
                  required
                  placeholder={
                    (isAStep ? `Enter step ${stepIndex + 1} title in French` : 'Please enter form title in French to proceed') as string
                  }
                  value={titleFrench}
                  onChange={(e) => {
                    setTitleFrench(e.target.value);
                  }}
                />
              ) : null}
            </Stack>
          </Stack>
        </DialogContent>
        <DialogActions>
          <Grid container p={2} pt={0} gap={1}>
            <Grid item xs={5.9}>
              <Button
                onClick={onClose}
                variant="outlined"
                color="secondary"
                fullWidth
                sx={{
                  borderRadius: '8px'
                }}
              >
                <FormattedMessage defaultMessage="Cancel" />
              </Button>
            </Grid>
            <Grid item xs={5.9}>
              {isAStep ? (
                <Button
                  onClick={() => {
                    onConfirm({ title, titleFrench });
                  }}
                  variant="contained"
                  color="primary"
                  fullWidth
                  sx={{
                    borderRadius: '8px'
                  }}
                >
                  <FormattedMessage defaultMessage="Add" />
                </Button>
              ) : (
                <Button
                  onClick={() => {
                    if (!title) return;
                    const steps = formData.steps;
                    steps[0] = {
                      title,
                      titleFrench,
                      items: steps[0]?.items ?? []
                    };
                    console.log(steps, 'steps');
                    store.dispatch({ type: SET_STEPS, payload: steps });
                    if (formData?.type === 'default') {
                      store.dispatch({ type: SET_DEFAULT_STEP_NAME, payload: title });
                      formData?.lng?.includes('fr') && store.dispatch({ type: SET_DEFAULT_STEP_NAME_FRENCH, payload: titleFrench });
                    }
                    formData?.type === 'stepper'
                      ? navigate('/forms/wizard', {
                          state: {
                            isFromStep: true,
                            isFromTemplate,
                            isEditing,
                            isClinicDocuments,
                            documentId,
                            targetAudience
                          }
                        })
                      : navigate('/forms/default', {
                          state: {
                            isFromStep: false,
                            isFromTemplate,
                            isEditing,
                            isClinicDocuments,
                            documentId,
                            targetAudience
                          }
                        });
                  }}
                  variant="contained"
                  color="primary"
                  fullWidth
                  sx={{
                    borderRadius: '8px'
                  }}
                  disabled={!title}
                >
                  {isEditing ? <FormattedMessage defaultMessage="Edit" /> : <FormattedMessage defaultMessage="Add" />}
                </Button>
              )}
            </Grid>
          </Grid>
        </DialogActions>
      </FormContainer>
    </Dialog>
    // </FormLocales>
  );
};

export default FormTitle;
